import { request } from '@luna/api';
import { getEnv } from '@luna/env';
import type { ExportSetDefinitionDto } from '@api-client/export-center';

export async function queryExportSetById(id: string): Promise<ExportSetDefinitionDto> {
    const { apiGatewayUrl } = getEnv();
    return request(`${apiGatewayUrl}export-center/public/export-sets/${id}`);
}
